import React from "react"
import { FastField, useFormikContext } from "formik"

import FormError from "../../../formError"

const BusinessInfo = () => {
  const { errors, touched } = useFormikContext()
  return (
    <>
      <div className="form-row justify-content-center">
        <div className="form-group col-md-12">
          <label htmlFor="business_name">Business Name</label>
          <FastField
            type="text"
            className="form-control"
            id="business_name"
            name="business_name"
          />

          <FormError
            touched={touched.business_name}
            message={errors.business_name}
          />
        </div>
      </div>

      <div className="form-row justify-content-cente">
        <div className="form-group col-md-6">
          <label htmlFor="account_number">BN/RC Number</label>
          <FastField
            className="form-control"
            id="bn_rc_number"
            name="bn_rc_number"
            placeholder=""
          />
          <label
            htmlFor="bn_rc_number"
            className="text-muted font-weight-light mt-2"
          >
            Example - BN1234567 or RC1234567
          </label>

          <FormError
            touched={touched.bn_rc_number}
            message={errors.bn_rc_number}
          />
        </div>

        <div className="form-group col-md-6">
          <label htmlFor="tin">TIN</label>
          <FastField type="text" className="form-control" id="tin" name="tin" />
          <label htmlFor="tin" className="text-muted font-weight-light mt-2">
            Example - 12345678-0001 or 1234567890
          </label>

          <FormError touched={touched.tin} message={errors.tin} />
        </div>

        <div className="form-group col-md-6">
          <label htmlFor="registration_date">Registration Date</label>
          <FastField
            type="date"
            className="form-control"
            id="registration_date"
            name="registration_date"
          />

          <FormError touched={touched.tin} message={errors.tin} />
        </div>
      </div>

      <div className="form-row">
        <div className="col-lg-12">
          <label htmlFor="type_of_business">Business address</label>
          <FastField
            className="form-control"
            id="business_address"
            name="business_address"
            as="textarea"
            rows="3"
          />
        </div>
      </div>
    </>
  )
}
export default BusinessInfo
